export const GROUPS_DATA_PATH = 'groups.data';
export const TICKET_TYPES_DATA_PATH = 'ticketTypes.data';
